export const SEARCH_MOVIE = {
  typeStr: "SEARCH_MOVIE",
  axiosUrl: `/search/`,
};

export const GET_GENRES = {
  typeStr: "GET_GENRES",
  axiosUrl: `/genre`,
};

export const GET_TRENDING_MOVIE = {
  typeStr: "GET_TRENDING_MOVIE",
  axiosUrl: `/trending/movie/week`,
};

export const GET_UPCOMING_MOVIE = {
  typeStr: "GET_UPCOMING_MOVIE",
  axiosUrl: `/movie/upcoming`,
};

export const GET_TRENDING_TVSHOWS = {
  typeStr: "GET_TRENDING_TVSHOWS",
  axiosUrl: `/trending/tv/week`,
};

export const GET_TVSHOWS_POPULAR = {
  typeStr: "GET_TVSHOWS_POPULAR",
  axiosUrl: `/tv/popular`,
};

export const GET_MOVIES_POPULAR = {
  typeStr: "GET_MOVIES_POPULAR",
  axiosUrl: `/movie/popular`,
};

export const GET_VIDEO_TRAILER = {
  typeStr: "GET_VIDEO_TRAILER",
  axiosUrl: ``,
};

export const GET_INFO = {
  typeStr: "GET_INFO",
  axiosUrl: ``,
};
